module.exports = (__webpack_require__(39702))(2543);